import { data } from './data';
import { duplicates } from './duplicates';
import { duplicatesPopup } from './duplicatesPopup';
import { dlCartAddEvent } from '../../events/cart/dl.cart.add.event';
import { dlCartRemoveEvent } from '../../events/cart/dl.cart.remove.event';
import { dlCartUpdateEvent } from '../../events/cart/dl.cart.update.event';
const parserHTML = new DOMParser();
const priceKeys = [
    'discounted_price',
    'final_line_price',
    'final_price',
    'line_level_total_discount',
    'old_line_price',
    'old_price',
    'original_line_price',
    'original_price'
];
const mathPrices = (cart) => {
    cart.total_price = cart.total_price / 100;
    cart.total_old_price = cart.total_old_price / 100;
    cart.items = cart.items.map(item => {
        priceKeys.forEach((key) => {
            item[key] = item[key] / 100;
        });
        return item;
    });
};
const getCart = async (itemData) => {
    try {
        const cart = await fetch('/?section_id=json_cart')
            .then(async (response) => await response.text())
            .then(html => {
            return JSON.parse(parserHTML.parseFromString(html, 'text/html').body.querySelector('#cartJSON').innerHTML);
        });
        mathPrices(cart);
        data.itemCount = cart.total_items;
        data.items = cart.items;
        data.totalPrice = cart.total_price;
        data.totalOldPrice = cart.total_old_price;
        dlCartUpdateEvent(cart);
        if (itemData !== undefined) {
            const duplicatesForItem = duplicates.getForItem(itemData);
            if (duplicatesForItem.length > 0 ||
                (itemData.sku !== 'Custom_TILE' && itemData.quantity > 1)) {
                duplicatesPopup(itemData, duplicatesForItem);
            }
            const addedItem = cart.items.find(item => item.key === itemData.key);
            addedItem !== undefined && dlCartAddEvent(addedItem, cart);
        }
    }
    catch (e) {
        console.log('Error with parsing cart: ', e);
    }
};
const updateQuantity = (quantity, line) => {
    const cartItem = Object.assign({}, data.items[line - 1]);
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/change.js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = async function () {
        if (xhr.status !== 200) {
            console.log(`Error ${xhr.status}: ${xhr.statusText}`);
        }
        else {
            await getCart();
            if (cartItem.quantity > quantity) {
                dlCartRemoveEvent([{
                        item: cartItem,
                        quantity: cartItem.quantity - quantity
                    }]);
            }
        }
    };
    xhr.send(JSON.stringify({ line, quantity }));
};
const updateCart = (upd) => {
    const detail = [];
    upd.forEach((quantity, itemIndex) => {
        const cartItem = Object.assign({}, data.items[itemIndex]);
        if (cartItem.quantity > quantity) {
            detail.push({
                item: cartItem,
                quantity: cartItem.quantity - quantity
            });
        }
    });
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/update.js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = async function () {
        if (xhr.status !== 200) {
            console.log(`Error ${xhr.status}: ${xhr.statusText}`);
        }
        else {
            await getCart();
            detail.length > 0 && dlCartRemoveEvent(detail);
        }
    };
    xhr.send(JSON.stringify({ updates: upd }));
};
export const ajax = { getCart, updateQuantity, updateCart };
